import { lazy } from 'react'

// E-commerce
export const EcommerceListPage = lazy(() =>
  import('@features/ecommerce/pages/EcommerceListPage').then((module) => ({
    default: module.EcommerceListPage,
  }))
)
export const CheckoutConfigCreatePage = lazy(() =>
  import('@features/ecommerce/pages/CheckoutConfigCreatePage').then((module) => ({
    default: module.CheckoutConfigCreatePage,
  }))
)
export const EcommerceDetailsPage = lazy(() =>
  import('@features/ecommerce/pages/EcommerceDetailsPage')
)

// In-stores
export const InStoresPage = lazy(() => import('@features/in-stores/pages/InStoresPage'))
export const InventoryDetailPage = lazy(() =>
  import('@features/in-stores/pages/inventory/InventoryDetailPage').then((module) => ({
    default: module.InventoryDetailPage,
  }))
)
export const OrderDetailPage = lazy(() =>
  import('@features/in-stores/pages/order/OrderDetailPage').then((module) => ({
    default: module.OrderDetailPage,
  }))
)
export const OrderWizardPage = lazy(() =>
  import('@features/in-stores/pages/order/OrderWizardPage').then((m) => ({
    default: m.OrderWizardPage,
  }))
)
export const TerminalDetailsPage = lazy(() =>
  import('@features/in-stores/pages/terminal/TerminalDetailsPage')
)

// Digital
export const DigitalListPage = lazy(() => import('@features/digital/pages/DigitalListPage'))

// Products
export const ProductsListPage = lazy(() => import('@features/products/pages/ProductsListPage'))
export const ProductsPage = lazy(() => import('@features/products/pages/ProductsPage'))
export const ProductDetailsPage = lazy(() =>
  import('@features/products/pages/ProductDetailsPage')
)

// POS
export const POSPage = lazy(() => import('@shared/components/pages/pos-page'))
export const POSSettingsPage = lazy(() =>
  import('@features/pos/pages/POSSettingsPage').then((m) => ({
    default: m.POSSettingsPage,
  }))
)
export const TaxSettingsPage = lazy(() =>
  import('@features/pos/pages/TaxSettingsPage').then((m) => ({
    default: m.TaxSettingsPage,
  }))
)
export const StoresListPage = lazy(() =>
  import('@features/stores/pages/StoresListPage').then((m) => ({
    default: m.StoresListPage,
  }))
)
export const StoreDetailPage = lazy(() =>
  import('@features/stores/pages/StoreDetailPage').then((m) => ({
    default: m.StoreDetailPage,
  }))
)
export const MenusPage = lazy(() => import('@features/pos/components/menus/pages/MenusPage'))
export const MenuBuilderPage = lazy(() => import('@features/pos/components/menus/pages/MenuBuilderPage'))
export const RecipesTabsPage = lazy(() => import('@features/pos/components/menus/pages/RecipesTabsPage'))
export const RecipeDetailPage = lazy(() => import('@features/pos/pages/RecipeDetailPage'))
export const RecipeCreatePage = lazy(() => import('@features/pos/pages/RecipeCreatePage'))
export const SchedulePage = lazy(() => import('@features/pos/components/schedule/pages/SchedulePage'))
export const PosInventoryPage = lazy(() => import('@features/pos/components/inventory/pages/InventoryPage'))
export const PosInventoryDetailPage = lazy(() => import('@features/pos/components/inventory/pages/PosInventoryDetailPage'))

// Bookings
export const CustomerBookingPortal = lazy(() =>
  import('@features/bookings/pages/CustomerBookingPortal')
)
export const BookingDetailView = lazy(() =>
  import('@features/bookings/pages/BookingDetailView')
)
export const RescheduleBookingFlow = lazy(() =>
  import('@features/bookings/pages/RescheduleBookingFlow')
)
export const CancelBookingFlow = lazy(() =>
  import('@features/bookings/pages/CancelBookingFlow')
)
export const BookingReminders = lazy(() =>
  import('@features/bookings/pages/BookingReminders')
)

// Web ordering (public, customer-facing)
export const WebOrderPage = lazy(() =>
  import('@/app/order/[storeId]/WebOrderPage').then((m) => ({
    default: m.WebOrderPage,
  }))
)
export const QROrderPage = lazy(() =>
  import('@/app/order/[storeId]/table/[tableId]/QROrderPage').then((m) => ({
    default: m.QROrderPage,
  }))
)
